export default "<input ng-model=\"model[options.key]\" type=\"hidden\" class=\"form-control\" record-id=\"model._id\">\n";